import {EventService} from "../event/event.service";

export class RequestRegistry {

  private youngestRequest: string = "";
  private requestIDs: string[] = [];

  constructor(private eventService: EventService) {}

  requestSend(requestID: string) {
    this.requestIDs.push(requestID);
    this.youngestRequest = requestID;
  }

  responseReceived(requestID: string) {
    if (this.requestInProgress()) {
      this.requestIDs.indexOf(requestID);
      this.requestIDs.splice(this.requestIDs.indexOf(requestID), 1);
      this.eventService.requestFinished();
    }
  }

  requestInProgress(): boolean {
    return this.requestIDs.length > 0;
  }
}
